import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export function NoInstallationsHome() {
  const { t } = useTranslation('common')

  return (
    <div className="flex min-h-svh items-center justify-center bg-background p-6">
      <Card className="w-full max-w-lg">
        <CardHeader>
          <CardTitle className="mb-2">{t('operatorsShell.noInstallationsTitle')}</CardTitle>
          <CardDescription>{t('operatorsShell.noInstallationsDescription')}</CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild className="w-full sm:w-auto">
            <Link to="/installations/new">{t('operatorsShell.noInstallationsCta')}</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
